import { render } from "./EditSystemUser.vue?vue&type=template&id=066c6b7a"
import script from "./EditSystemUser.vue?vue&type=script&lang=js"
export * from "./EditSystemUser.vue?vue&type=script&lang=js"

import exportComponent from "D:\\fz\\1_Task\\hr.haite.sg\\orangehrm-5.2\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__